export const CALIBRATION_STATUS = {
  INITIAL: 'INITIAL',
  ACTIVATE: 'ACTIVATE',
  INACTIVE: 'INACTIVE',
}
